<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useKpiStore } from '@/stores/useKpiStore'
import ChartBar from '@/components/data-visualization/charts/ChartBar.vue'

const kpiStore = useKpiStore()

const {
  kpiSaleOrderCreate,
  kpiSaleOrderSigned,
  loadingSaleOrderCreateKpi,
  loadingSaleOrderSignedKpi,
  errorSaleOrderCreate,
  errorSaleOrderSigned,
} = storeToRefs(kpiStore)
</script>

<template>
  <ChartBar
    :data="kpiSaleOrderCreate || []"
    title="Devis Créés"
    :loading="loadingSaleOrderCreateKpi"
    :error="errorSaleOrderCreate"
  />
  <ChartBar
    :data="kpiSaleOrderSigned || []"
    title="Devis Signés"
    :loading="loadingSaleOrderSignedKpi"
    :error="errorSaleOrderSigned"
  />
</template>
